module.exports = __webpack_public_path__ + "img/check.72815337.svg";